module.exports = __webpack_public_path__ + "img/NENEZ.0e4a018e.png";